import {
  Component,
  computed,
  inject,
  input,
  linkedSignal,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MbscResource } from '@mobiscroll/angular';
import { RosterContent, Task } from '@softapps/pms/roster';
import { GarageTask, TaskService } from '@softapps/werkstatt/garage-core';
import {
  FieldValidationDirective,
  InputComponent,
  MultilineInputComponent,
  ResolvableModal,
  Validators,
} from '@softline/ui-core';
import { SelectComponent, SelectOptionDirective } from '@softline/ui-core/combo-box';
import { DateInputComponent } from '@softline/ui-core/date-input';
import { TimeInputComponent } from '@softline/ui-core/date-input';
import { calendarEventValidator } from '../../helper/calendar-event.validators';

@Component({
  selector: 'soft-garage-roster-task-form',
  imports: [
    ReactiveFormsModule,
    FieldValidationDirective,
    DateInputComponent,
    TimeInputComponent,
    InputComponent,
    MultilineInputComponent,
    SelectOptionDirective,
    SelectComponent,
  ],
  templateUrl: './garage-roster-task-form.modal.html',
  styleUrl: './garage-roster-task-form.modal.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class GarageRosterTaskFormComponent
  extends ResolvableModal<Task | 'CANCEL'>
  implements OnInit
{
  private readonly garageTaskService = inject(TaskService);
  readonly resources = input<MbscResource[]>();
  readonly resource = input<(number | string)[]>();
  readonly event = input<RosterContent>();

  readonly tasks = linkedSignal<GarageTask[]>(() => this.garageTaskService.tasks());

  _resource = computed(() => {
    const currentResource = this.resource()?.[0];
    return this.resources()?.find((o) => o.id === currentResource) ?? null;
  });

  hasCalendarEvent = computed(() => {
    const event = this.event();
    return event;
  });

  statuses = [
    { id: 'U', label: 'Undefiniert' },
    { id: 'E', label: 'Erledigt' },
  ];

  readonly form = new FormGroup(
    {
      task: new FormControl<string>('', {}),
      comment: new FormControl<string>('', {}),
      beginTime: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required()],
      }),
      beginDay: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required()],
      }),
      endDay: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required()],
      }),
      endTime: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required()],
      }),
      employee: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required()],
      }),
      state: new FormControl<string>('', {}),
      //type: new FormControl<string | null>(null),
    },
    { validators: [calendarEventValidator] }
  );

  ngOnInit() {
    const event = this.event();
    if (event) {
      this.form.patchValue({
        beginTime: `${(event?.start ?? '').toString().split('T')[1]}`,
        beginDay: event?.start?.toString().split('T')[0],
        endDay: event?.end?.toString().split('T')[0],
        endTime: `${(event?.end ?? '').toString().split('T')[1]}`,
        employee: this._resource()?.id + '',
        state: event?.additionalData?.state,
        comment: event?.additionalData?.comment,
      });
    }
  }

  async submit(): Promise<void> {
    if (!this.form.valid) return;

    const formValue = this.form.getRawValue();
    const data: any = {
      endTime: formValue.endTime,
      beginTime: formValue.beginTime,
      beginDay: formValue.beginDay,
      endDay: formValue.endDay,
      taskId: formValue?.task,
      comment: formValue?.comment,
      employeeId: formValue?.employee,
      state: formValue?.state,
    };
    this.resolve(data);
  }
}
